module.exports = __webpack_public_path__ + "static/media/desk_100.d9aa1567.ico";